<template>
  <SfSidebar
    :visible="isVisible"
    class="sf-sidebar--right sf-sidebar--icon sf-sidebar__data-sheet"
    @close="closeModal"
  >
    <div
      v-if="product"
      class="data-sheet-content"
    >
      <SfHeading
        class="sf-heading--left"
        :title="product.name || 'Produktdetails'"
        :level="2"
      />

      <div
        v-if="thumbnail"
        class="data-sheet-content__image"
      >
        <SfImage
          :src="thumbnail"
          :alt="product.name"
          width="280"
          height="280"
        />
      </div>

      <div
        v-if="descriptionHtml"
        class="data-sheet-content__description"
        v-html="descriptionHtml"
      />

      <template v-if="getCustomAttributes.length">
        <SfHeading
          class="sf-heading--left data-sheet-content__datasheet-title"
          title="Datenblatt"
          :level="3"
        />
        <div class="sf-sidebar-data-sheet-content">
          <AProductAttribute
            v-for="(attribute, i) in getCustomAttributes"
            :key="i"
            :product="product"
            :attribute="attribute"
            class="product__property"
          />
        </div>
      </template>
    </div>
  </SfSidebar>
</template>

<script>
import { mapGetters } from 'vuex'
import { SfSidebar, SfHeading, SfImage } from '@storefront-ui/vue'
import { getThumbnailForProduct } from '@vue-storefront/core/modules/cart/helpers'
import AProductAttribute from 'theme/components/atoms/a-product-attribute'

export default {
  name: 'SidebarDataSheet',
  components: {
    SfSidebar,
    SfHeading,
    SfImage,
    AProductAttribute
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    modalData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  computed: {
    ...mapGetters({
      attributesByCode: 'attribute/attributeListByCode'
    }),
    product () {
      return (this.modalData && this.modalData.payload) || null
    },
    thumbnail () {
      return this.product ? getThumbnailForProduct(this.product) : ''
    },
    descriptionHtml () {
      if (!this.product) return ''
      return this.product.short_description || this.product.description || ''
    },
    getCustomAttributes () {
      if (!this.product) return []

      return Object.values(this.attributesByCode)
        .filter((a) => {
          return (
            a.is_visible &&
            a.is_user_defined &&
            (parseInt(a.is_visible_on_front) || a.is_visible_on_front === true) &&
            this.product[a.attribute_code]
          )
        })
        .sort((a, b) => {
          return a.position - b.position
        })
    }
  },
  methods: {
    closeModal () {
      this.$emit('close', this.modalData.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.data-sheet-content {
  &__image {
    margin: 0 0 1rem;

    ::v-deep .sf-image {
      width: 100%;
      max-width: 280px;
      border-radius: 4px;
      overflow: hidden;
      background: var(--c-light);

      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }
  }

  &__description {
    margin-bottom: 1.25rem;
    line-height: 1.5;
    color: var(--c-dark-variant);

    ::v-deep p:last-child {
      margin-bottom: 0;
    }
  }

  &__datasheet-title {
    margin: 0 0 0.75rem;
  }
}
</style>
